import React from 'react'
import Lottie from 'lottie-react'
import styled from 'styled-components'

import LoadingJson from '@/assets/common/loading.json'

const Loading = () => {
  return (
    <LoadingWrap>
      <Lottie animationData={LoadingJson} className="lottie" />
    </LoadingWrap>
  )
}
export default Loading

const LoadingWrap = styled.div`
  width: 100%;
  height: 100vh;

  position: fixed;
  top: 0;
  left: 0;

  background: #000000;
  opacity: 0.4;

  display: flex;
  align-items: center;
  justify-content: center;

  z-index: 9999;

  .lottie {
    width: 148px;
    height: 148px;
  }
`
